// list atrybutów

import React, { FC } from 'react';
import { Check2, X, FileEarmark, FileEarmarkPdf } from 'react-bootstrap-icons';
import { Grid } from '@mui/material';
import classnames from 'classnames';
import { Link } from 'react-router-dom';

import { ITechnicalAttribute, ILogisticAttribute, IProductFile } from 'api/types';

import styles from 'theme/pages/Product/components/AttributeList/AttributeList.module.scss';

// typ danych wejściowych
interface IProps {
  attributes: Array<ITechnicalAttribute | ILogisticAttribute | IProductFile>;
}

const AttributeList: FC<IProps> = ({ attributes }) => {
  // funcja sprawdzająca czy atrybut jest plikiem
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const isFile = (test: any): test is IProductFile => typeof test.extension === 'string';

  // funcja renderująca wartość atrybutu
  const renderValue = (attribute: ITechnicalAttribute | ILogisticAttribute) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isTechnicalAttribute = (test: any): test is ITechnicalAttribute =>
      typeof test.type === 'string';

    return isTechnicalAttribute(attribute) && attribute.type === 'boolean' ? (
      attribute.value ? (
        <Check2 className={styles.green} />
      ) : (
        <X className={styles.red} />
      )
    ) : (
      <>
        {!isTechnicalAttribute(attribute) && <img src={attribute.icon} alt="" />} {attribute.value}
      </>
    );
  };

  return (
    <div
      className={classnames(
        styles.attributeList,
        'StylePath-Pages-Product-components-AttributeList'
      )}>
      <table className={styles.table}>
        <tbody>
          {attributes.map((attribute) => (
            <tr className={styles.row} key={attribute.name}>
              {isFile(attribute) ? (
                <td colSpan={2} className={styles.attributeFile}>
                  {attribute.extension === 'pdf' ? <FileEarmarkPdf /> : <FileEarmark />}
                  <a className={styles.link} href={attribute.url} target="_blank" rel="noreferrer">
                    <strong>{attribute.name}</strong>
                  </a>
                </td>
              ) : (
                <>
                  <td className={styles.attributeName}>{attribute.name}</td>
                  <td className={styles.attributeValue}>{renderValue(attribute)}</td>
                </>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AttributeList;
